import { router } from "@inertiajs/react";
import Header from "../Component/Header";

const formatCurrency = (value) =>
    new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(Number(value) || 0);

const formatNumber = (value) =>
    new Intl.NumberFormat("id-ID", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(Number(value) || 0);

const bonusTypeLabel = (value) => (Number(value) === 1 ? "Nominal" : "Percent");
const variantTypeLabel = (value) => (Number(value) === 1 ? "Custom" : "Normal");
const formatBonus = (amount, bonusType) =>
    Number(bonusType) === 0
        ? `${new Intl.NumberFormat("id-ID", {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
          }).format(Number(amount) || 0)}%`
        : formatCurrency(amount);

export default function Show({ data }) {
    const variants = data?.variants ?? [];
    const imageUrl = data?.prod_image ? `/storage/${data.prod_image}` : null;

    return (
        <>
            <Header />
            <main id="content" className="pb-14 sm:pb-16">
                <div className="max-w-[85rem] px-4 sm:px-6 lg:px-8 mx-auto">
                    <div className="py-2 sm:pb-0 sm:pt-5 space-y-5">
                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 sm:gap-5">
                            <div className="inline-flex sm:justify-end items-center gap-x-3">
                                <p className="text-sm text-muted-foreground-1">Product</p>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-6 gap-5">
                            <div className="lg:col-span-4 space-y-4">
                                <div className="flex flex-col bg-card border border-card-line overflow-hidden rounded-xl shadow-2xs">
                                    <div className="py-3 px-5 flex justify-between items-center gap-x-5 border-b border-card-header">
                                        <h2 className="inline-block font-semibold text-foreground">
                                            Product Detail
                                        </h2>
                                    </div>

                                    <div className="p-5 space-y-5">
                                        <div>
                                            <label className="block mb-2 text-sm font-medium text-foreground">
                                                Product Name
                                            </label>
                                            <input
                                                type="text"
                                                value={data?.prod_name ?? ""}
                                                disabled
                                                className="py-2 px-3 block w-full bg-layer border border-layer-line rounded-lg sm:text-sm text-layer-foreground disabled:opacity-100 disabled:text-layer-foreground"
                                            />
                                        </div>

                                        <div>
                                            <label className="block mb-2 text-sm font-medium text-foreground">
                                                Product Status
                                            </label>
                                            <input
                                                type="text"
                                                value={data?.prod_status === 1 ? "Active" : "Inactive"}
                                                disabled
                                                className="py-2 px-3 block w-full bg-layer border border-layer-line rounded-lg sm:text-sm text-layer-foreground disabled:opacity-100 disabled:text-layer-foreground"
                                            />
                                        </div>

                                        <div>
                                            <label className="block mb-2 text-sm font-medium text-foreground">
                                                Product Image
                                            </label>
                                            {imageUrl ? (
                                                <img
                                                    src={imageUrl}
                                                    alt={data?.prod_name ? `${data.prod_name} image` : "Product image"}
                                                    className="h-48 w-full max-w-md rounded-lg border border-layer-line object-cover"
                                                />
                                            ) : (
                                                <p className="text-sm text-muted-foreground-2">No image uploaded.</p>
                                            )}
                                        </div>

                                        <div className="space-y-3">
                                            <h3 className="text-sm font-medium text-foreground">Variants</h3>

                                            {variants.length === 0 ? (
                                                <p className="text-sm text-muted-foreground-2">No variants available.</p>
                                            ) : (
                                                <div className="overflow-x-auto">
                                                    <table className="min-w-full divide-y divide-table-line">
                                                        <thead>
                                                            <tr>
                                                                <th className="py-2.5 px-3 text-start text-sm font-normal text-muted-foreground-1">Name</th>
                                                                <th className="py-2.5 px-3 text-start text-sm font-normal text-muted-foreground-1">Total Earned Coin</th>
                                                                <th className="py-2.5 px-3 text-start text-sm font-normal text-muted-foreground-1">Price</th>
                                                                <th className="py-2.5 px-3 text-start text-sm font-normal text-muted-foreground-1">Bonus</th>
                                                                <th className="py-2.5 px-3 text-start text-sm font-normal text-muted-foreground-1">Bonus Type</th>
                                                                <th className="py-2.5 px-3 text-start text-sm font-normal text-muted-foreground-1">Variant Type</th>
                                                                <th className="py-2.5 px-3 text-start text-sm font-normal text-muted-foreground-1">Status</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="divide-y divide-table-line">
                                                            {variants.map((variant) => (
                                                                <tr key={variant.prod_var_id}>
                                                                    <td className="py-3 px-3 text-sm text-foreground">{variant.prod_var_name}</td>
                                                                    <td className="py-3 px-3 text-sm text-muted-foreground-2">{formatNumber(variant.total_earned_coin)}</td>
                                                                    <td className="py-3 px-3 text-sm text-muted-foreground-2">{formatCurrency(variant.prod_var_price)}</td>
                                                                    <td className="py-3 px-3 text-sm text-muted-foreground-2">{formatBonus(variant.prod_var_bonus, variant.prod_var_bonus_type)}</td>
                                                                    <td className="py-3 px-3 text-sm text-muted-foreground-2">{bonusTypeLabel(variant.prod_var_bonus_type)}</td>
                                                                    <td className="py-3 px-3 text-sm text-muted-foreground-2">{variantTypeLabel(variant.prod_var_type)}</td>
                                                                    <td className="py-3 px-3">
                                                                        <span className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ${variant.prod_var_status === 1 ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}>
                                                                            {variant.prod_var_status === 1 ? "Active" : "Inactive"}
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="flex justify-end gap-2">
                                    <button
                                        type="button"
                                        onClick={() => router.visit(`/panel/products/${data.prod_id}/edit`)}
                                        className="py-2 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg bg-primary border border-primary-line text-primary-foreground hover:bg-primary-hover"
                                    >
                                        Edit
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => router.visit("/panel/products")}
                                        className="py-2 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg bg-layer border border-layer-line text-layer-foreground hover:bg-layer-hover"
                                    >
                                        Back to Products
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}
